import { io } from 'socket.io-client';
const config = require('../config.json')
// "undefined" means the URL will be computed from the `window.location` object
const URL = config.backend_url;

export const socket = io(URL);